import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

const CategoryFilter = ({ productCategories, value, onChange }) => {
  const { t } = useTranslation()

  return (
    <ComboBox
      menuItems={productCategories?.map(category => ({ value: category.id, label: category.name }))}
      label={t('Categoría')}
      handleChange={e => onChange(e.target.value)}
      value={value}
      fullWidth
    />
  )
}

export default CategoryFilter
